import React, { useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Alert, Button } from 'antd';

import { warningsFactory } from 'v2/services/warning';

import NoDangerouslyHTML from '../NoDangerouslyHTML';

const matchesPageUrl = (pattern: string): boolean => {
  const regexPattern = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*');
  const regex = new RegExp(`^${regexPattern}$`);

  return regex.test(window.location.href);
};

const GlobalWarning = () => {
  const [answeredWarnings, setAnsweredWarnings] = useState([]);
  const [warnings] = useObservable(() => warningsFactory.getWarnings(), []);

  const warningsNotAnswered =
    warnings?.filter(warning => {
      if (answeredWarnings.includes(warning.id)) return false;

      if (!warning.pages?.length) return true;

      return warning.pages.some(page => matchesPageUrl(page.url));
    }) || [];

  const closeAlert = (id: string) => {
    const newAnsweredWarnings = [...answeredWarnings, id];
    localStorage.setItem('warnings', newAnsweredWarnings.toString());
    setAnsweredWarnings(newAnsweredWarnings);
  };

  const shouldShowCloseButton = (id: string) => {
    const notShow = ['eb3bf692-57e9-4cb0-88f0-2afd24380212'];

    return !notShow.includes(id);
  };

  useEffect(() => {
    const storage = localStorage.getItem('warnings');
    setAnsweredWarnings(storage?.split(',') || []);
  }, []);

  if (!warningsNotAnswered?.length) {
    return null;
  }

  return (
    <div className='mb-5 flex flex-col gap-4'>
      {warningsNotAnswered.map((alert, index) => (
        <div
          key={index}
          className='[&_.ant-alert-action]:ms-0 [&_.ant-alert-action]:ps-0 max-[576px]:[&_.ant-alert]:flex-wrap max-[576px]:[&_.ant-alert-action]:mt-2 max-[576px]:[&_.ant-alert-action]:w-full'
        >
          <Alert
            type={alert.type}
            message={alert.title}
            description={
              <div className='me-auto'>
                <NoDangerouslyHTML html={alert.description} />
              </div>
            }
            action={
              <div className='flex gap-2'>
                {!!alert.link && (
                  <Button
                    variant='outlined'
                    color='default'
                    href={alert.link}
                    target='_blank'
                    rel='noopener noreferrer'
                    aria-label='saiba mais'
                  >
                    Saiba mais
                  </Button>
                )}
                {shouldShowCloseButton(alert.id) && (
                  <Button variant='outlined' color='default' onClick={() => closeAlert(alert.id)} aria-label='fechar'>
                    Entendi
                  </Button>
                )}
              </div>
            }
            showIcon
          />
        </div>
      ))}
    </div>
  );
};

export default GlobalWarning;
